module.exports = __webpack_public_path__ + "static/img/5_2_2.ce3aaa88.jpg";